"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormContainer = void 0;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _events = require("../../../../types/events");
var _keyCodes = require("../../../../types/keyCodes");
var _authentication = require("../../../../types/authentication");
var _requestStatus = require("../../../../types/requestStatus");
var _ContentLayout = require("../../../../components/ContentLayout");
var _PhoneField = require("../../../../components/PhoneField");
var _view = require("../../../../types/view");
var _tracking = require("../../../../utils/tracking");
var _FieldGroupLayout = require("../../../../components/FieldGroupLayout");
var _twoFactorPhone = require("../../../../actions/twoFactorPhone");
var _login = require("../../../../actions/login");
var _view2 = require("../../../../actions/view");
var _authentication2 = require("../../../../actions/authentication");
var _events2 = require("../../../../actions/events");
var _selectors = require("./selectors");
var _autoFocusDisabled = require("../../../../selectors/autoFocusDisabled");
var _validation = require("../../../../utils/validation");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const FormContainer = _ref => {
  let {
    useSelector,
    useDispatch
  } = _ref;
  const dispatch = useDispatch();
  const login = useSelector(_selectors.loginSelector);
  const phone = useSelector(_selectors.phoneSelector);
  const twoFactorStatus = useSelector(_selectors.twoFactorStatusSelector);
  const isSubmitDisabled = useSelector(_selectors.isSubmitDisabledSelector);
  const isAutosubmitEnabled = useSelector(_selectors.isAutosubmitEnabledSelector);
  const phoneError = useSelector(_selectors.phoneErrorSelector);
  const autoFocusDisabled = useSelector(_autoFocusDisabled.selectAutoFocusDisabled);
  const isPhoneInvalid = useSelector(_selectors.isPhoneInvalidSelector);

  // FORM
  const [isChanged, setIsChanged] = React.useState(false);
  const [isTouched, setIsTouched] = React.useState(false);

  // PHONE
  const phoneRef = React.useRef(null);
  const handlePhoneChange = React.useCallback(value => {
    const newValue = value.replace(/\s/gi, '');
    dispatch((0, _twoFactorPhone.changePhone)(newValue));
    setIsChanged(true);
  }, [dispatch]);

  // SUBMIT
  const handleSubmit = React.useCallback(() => {
    (0, _tracking.trackTwoFactorContinueClick)(_authentication.ETwoFactorType.Phone);
    setIsTouched(true);
    if (isSubmitDisabled) {
      return;
    }
    if (isPhoneInvalid) {
      if (phoneRef.current) {
        phoneRef.current.focus();
      }
      return;
    }
    dispatch((0, _twoFactorPhone.sendCodeMultichannel)());
    setIsChanged(false);
    dispatch((0, _events2.emit)(_events.EEventType.TwoFactorContinueClick));
  }, [dispatch, isSubmitDisabled, isPhoneInvalid]);
  React.useEffect(() => {
    if ((0, _validation.isPhone)(phone) && isAutosubmitEnabled) {
      handleSubmit();
      dispatch((0, _twoFactorPhone.changeAutosubmit)(false));
    }
  }, [dispatch, phone, isAutosubmitEnabled, handleSubmit]);
  const handleBackClick = React.useCallback(() => {
    (0, _tracking.trackTwoFactorClose)(_authentication.ETwoFactorType.Phone);
    dispatch((0, _authentication2.reset)());
    dispatch((0, _login.changeLogin)(login));
    dispatch((0, _view2.changeView)(_view.EActiveView.AuthenticationRegistration));
  }, [dispatch, login]);
  const handlePreventSubmit = React.useCallback(e => {
    e.preventDefault();
  }, []);
  const handleSubmitOnEnter = React.useCallback(e => {
    if (e.keyCode === _keyCodes.EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  return /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement("form", {
    onSubmit: handlePreventSubmit
  }, /*#__PURE__*/React.createElement(_FieldGroupLayout.FormFieldGroupLayout, {
    content: /*#__PURE__*/React.createElement(_PhoneField.PhoneField, {
      autoComplete: "tel",
      autoFocus: !autoFocusDisabled,
      inputRef: phoneRef,
      name: "phone",
      id: "two_factor-phone",
      value: phone,
      onFocus: _tracking.trackTwoFactorPhoneInputClick,
      errorMessage: twoFactorStatus === _requestStatus.ERequestStatus.Failed && !isChanged ? phoneError : undefined,
      invalid: isTouched && (twoFactorStatus === _requestStatus.ERequestStatus.Failed && !isChanged || isPhoneInvalid),
      disabled: isSubmitDisabled,
      onKeyDown: handleSubmitOnEnter,
      onValueChange: handlePhoneChange
    }),
    buttons: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "ResumeTwoFactorBtn",
      theme: "fill_primary",
      fullWidth: true,
      loading: isSubmitDisabled,
      disabled: isSubmitDisabled,
      onClick: handleSubmit
    }, "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C"), /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "CancelTwoFactorBtn",
      theme: "fill_secondary",
      fullWidth: true,
      onClick: handleBackClick
    }, "\u041E\u0442\u043C\u0435\u043D\u0430"))
  })));
};
exports.FormContainer = FormContainer;